import React from 'react'
import {API_BASE_URL, MEDIA_URL} from '../../constants'
import axios from 'axios'
import {getToken, setUserProfile} from '../../storage'
import StateSelect from '../client/stateselect'
import 'react-select/dist/react-select.css'
import {NotificationManager} from 'react-notifications'
import {AdditionalParam} from '../modal/modal'


class Profile extends React.Component {

  constructor(){
    super()
    this.state = {loading:true}
    this.getProfile = this.getProfile.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleStateChage = this.handleStateChage.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.addParam = this.addParam.bind(this)
    this.removeParam = this.removeParam.bind(this)
    this.logoInput = React.createRef();
    this.logoInput2 = React.createRef();
    this.handleUpdateLogo = this.handleUpdateLogo.bind(this)
    document.title = "Edit Profile"
  }

  addParam( k,v) {
    let currentItem = this.state.company_profile
    let existingParams = this.state.company_profile.additional_params
    if(typeof existingParams !== "undefined" && existingParams !== null) {
        existingParams.push({key:k, value:v})
    }
    else {
      existingParams = []
      existingParams.push({key:k, value:v})
    }

    currentItem['additional_params'] = existingParams
    this.setState({company_profile:currentItem})

  }

  removeParam(k) {
    let currentItem = this.state.company_profile
    let existingParams = this.state.company_profile.additional_params

    existingParams = existingParams.filter(param => param.key!==k)


    currentItem['additional_params'] = existingParams
    this.setState({company_profile:currentItem})
  }

  handleInputChange(event) {
    const target = event.target;
    let value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    let currentItem = this.state.company_profile
        currentItem[name] = value
        this.setState({
          company_profile: currentItem
       });
  }

  handleStateChage(option) {
    let currentItem = this.state.company_profile
        currentItem['state_ui'] = {state_name:option.state_name, state_code:option.state_code}
        currentItem['state'] = option.state_name
        currentItem['state_code'] = option.state_code
        this.setState({
          company_profile: currentItem
       });
  }

  handleUpdateLogo(event) {
    event.preventDefault()
    if(this.logoInput.current.files.length) {
      axios({
        url: '/edit_company_profile_logo/',
        method: 'post',
        baseURL: API_BASE_URL,
        transformRequest: [(data, headers)=> {
            let formData = new FormData()
            formData.append('file', this.logoInput.current.files[0])
            return formData;
          }],
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        }
      }).then((response)=>{
        if(response.status === 200) {

          setUserProfile(response.data.company_profile)
          this.setState({updating_profile:false})
          NotificationManager.success("Logo updated successfully")
          setTimeout(()=>{
            window.location.reload()
          }, 700)
        }
      }).catch((err)=>{
        if(err.response.data) {
          NotificationManager.error(err.response.data.msg)
        }

      })
    }
  }

  handleUpdateLogo2=(event)=> {
    event.preventDefault()
    if(this.logoInput2.current.files.length) {
      axios({
        url: '/edit_company_profile_logo_2/',
        method: 'post',
        baseURL: API_BASE_URL,
        transformRequest: [(data, headers)=> {
            let formData = new FormData()
            formData.append('file', this.logoInput2.current.files[0])
            return formData;
          }],
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          },
          post: {
            'Content-Type': 'multipart/form-data;'
          }
        }
      }).then((response)=>{
        if(response.status === 200) {

          setUserProfile(response.data.company_profile)
          this.setState({updating_profile:false})
          NotificationManager.success("Logo updated successfully")
          setTimeout(()=>{
            window.location = "/"
          }, 700)
        }
      }).catch((err)=>{
        if(err.response.data) {
          NotificationManager.error(err.response.data.msg)
        }

      })
    }
  }

  handleSubmit(event) {
    this.setState({updating_profile:true})
    event.preventDefault()
    if(event.target.name === 'createGstForm' || event.target.name === "createUnitForm"){
      return false
    }

    axios({
      url: '/edit_company_profile/',
      method: 'post',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        },
        post: {
          'Content-Type': 'multipart/form-data;'
        }
      },
      data: this.state.company_profile
    }).then((response)=> {
      if(response.status === 200) {

        setUserProfile(response.data.company_profile)
        this.setState({updating_profile:false})
        NotificationManager.success("Profile updated successfully")
        setTimeout(()=>{
          this.props.history.push("/")
        }, 700)
      }
    }).catch((err)=> {
      this.setState({updating_profile:false})
    })

  }

  componentDidMount() {
    this.getProfile().then((response)=>{
      if(response.status===200) {
        let company_profile = response.data.company_profile
        company_profile['state_ui'] = {state_name:company_profile.state, state_code:company_profile.state_code}
        this.setState({loading:false, company_profile: response.data.company_profile})
      }
    }).catch((err)=>{
      if(typeof err.response === "undefined") {
            this.setState({loading_error: 'Could not connect to server', loading:false})
      }
      else {
          this.setState({loading_error: err.response.statusText, loading:false})
      }
    })
  }

  getProfile() {
    return axios({
      url: '/get_company_profile/',
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  render() {

    let editForm, logoForm, logo2Form

    let submitButton = <input type="submit" className="btn btn-success" value="save" />
    if(this.state.updating_profile) {
      submitButton = <input type="submit" className="btn btn-success" value="saving.." disabled />
    }

    if(!this.state.loading && typeof this.state.loading_error !== "undefined") {
      editForm = this.state.loading_error
    }
    else if(!this.state.loading){

      let leftForm , rightForm


      let profile = this.state.company_profile
      let logo, logo2
      if(profile.logo) {
        logo = <img src={MEDIA_URL+profile.logo} className="img-thumbnail"/>
      }
      if (profile.logo_2) {
        logo2 = <img src={MEDIA_URL+profile.logo_2} className="img-thumbnail"/>
      }
      logoForm = <form>
        <div className="form-group">
        <div className="col-sm-2">
          <h4>Company Logo 1</h4>

        </div>
        <div className="col-sm-3">
  {logo}
        </div>

        <div className="col-sm-6">
              <input type="file" ref={this.logoInput} accept="image/*" />
              <button onClick={this.handleUpdateLogo} className="btn btn-sm btn-success">Update</button>
        </div>
        </div>
      </form>

      logo2Form =<form>
        <div className="form-group">
        <div className="col-sm-2">
          <h4>Company Logo 2</h4>

        </div>
        <div className="col-sm-3">
  {logo2}
        </div>

        <div className="col-sm-6">
              <input type="file" ref={this.logoInput2} accept="image/*" />
              <button onClick={this.handleUpdateLogo2} className="btn btn-sm btn-success">Update</button>
        </div>
        </div>
      </form>

      leftForm = (<div>
        <div className="form-group">
    <label className="col-sm-3 ">Company Name *</label>
    <div className="col-sm-9">
        <input type="text" name="company_name" value={profile.company_name} className="form-control" onChange={this.handleInputChange} />
    </div>
</div>

<div className="form-group">
<label className="col-sm-3 ">Tag Line</label>
<div className="col-sm-9">
<input type="text" name="tag_line" value={profile.tag_line} className="form-control" onChange={this.handleInputChange} />
</div>
</div>


<div className="form-group">
<label className="col-sm-3 ">Tax Type</label>
<div className="col-sm-9">
  <select value={profile.tax_type} name="tax_type" className="form-control" onChange={this.handleInputChange}>
    <option value={"G"}>GST</option>
    <option value={"C"}>Composition Scheme</option>
  </select>
</div>
</div>

<div className="form-group">
    <label className="col-sm-3 ">Phone</label>
    <div className="col-sm-9">
        <input type="text" value={profile.phone} name="phone" className="form-control" onChange={this.handleInputChange} />
    </div>
</div>
<div className="form-group">
    <label className="col-sm-3 ">Email</label>
    <div className="col-sm-9">
        <input type="text" value={profile.email} name="email" className="form-control" onChange={this.handleInputChange} />
    </div>
</div>

<div className="form-group">
    <label className="col-sm-3 ">Notifications Email</label>
    <div className="col-sm-9">
        <input type="text" value={profile.notifications_email} name="notifications_email" className="form-control" onChange={this.handleInputChange} />
    </div>
</div>

<div className="form-group">
    <label className="col-sm-3 ">GSTIN</label>
    <div className="col-sm-9">
        <input type="text" value={profile.gstin} name="gstin" className="form-control" onChange={this.handleInputChange} />
    </div>
</div>
<div className="form-group">
    <label className="col-sm-3 ">PAN</label>
    <div className="col-sm-9">
        <input type="text" value={profile.pan} name="pan" className="form-control" onChange={this.handleInputChange} />
    </div>
</div>
<div className="form-group">
    <label className="col-sm-3 ">Address</label>
    <div className="col-sm-9">
        <input type="text" value={profile.address} name="address" className="form-control" onChange={this.handleInputChange} />
    </div>
</div>
<div className="form-group">
    <label className="col-sm-3 ">City</label>
    <div className="col-sm-9">
        <input type="text" value={profile.city} name="city" className="form-control" onChange={this.handleInputChange} />
    </div>
</div>
<div className="form-group">
    <label className="col-sm-3 ">State</label>
    <div className="col-sm-9">
        <StateSelect value={profile.state_ui} name="state" handleChange={this.handleStateChage} />
    </div>
</div>
<div className="form-group">
    <label className="col-sm-3 ">Pincode</label>
    <div className="col-sm-9">
        <input type="text" value={profile.pin} name="pin" className="form-control" onChange={this.handleInputChange} />
    </div>
</div>





        </div>)


        rightForm = (<div>
          <div className="form-group">
        <label className="col-sm-12 text-center">Bank Details</label>

        </div>
          <div className="form-group">
        <label className="col-sm-3 ">Bank Name</label>
        <div className="col-sm-9">
          <input type="text" value={profile.bank_name} name="bank_name" className="form-control" onChange={this.handleInputChange} />
        </div>
        </div>
        <div className="form-group">
        <label className="col-sm-3 ">Branch Name</label>
        <div className="col-sm-9">
          <input type="text" value={profile.branch_name} name="branch_name" className="form-control" onChange={this.handleInputChange} />
        </div>
        </div>
        <div className="form-group">
        <label className="col-sm-3 ">Account No</label>
        <div className="col-sm-9">
          <input type="text" value={profile.account_no} name="account_no" className="form-control" onChange={this.handleInputChange} />
        </div>
        </div>
        <div className="form-group">
        <label className="col-sm-3 ">IFSC Code</label>
        <div className="col-sm-9">
          <input type="text" value={profile.ifsc_code} name="ifsc_code" className="form-control" onChange={this.handleInputChange} />
        </div>
        </div>
        <AdditionalParam additional_params={profile.additional_params} addParam={this.addParam} removeParam={this.removeParam} />
          </div>)


     editForm = (<div>


                      <div className="col-sm-12">
                        <div className="panel panel-default">
                          <div className="panel-body">
                            <form className="form-horizontal" onSubmit={this.handleSubmit}>
                              <div className="form-group">
                                  <div className="col-sm-7">
                                    {leftForm}
                                  </div>
                                  <div className="col-sm-5">
                                    {rightForm}
                                  </div>
                              </div>
                              <div className="form-action-group text-center">
                                 {submitButton}
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="panel panel-default">
                          <div className="panel-body">
                            {logoForm}
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="panel panel-default">
                          <div className="panel-body">
                            {logo2Form}
                          </div>
                        </div>
                      </div>


                  </div>)
    }

    return <div>
          <section className="medium">
          <h3 >Company Details</h3>
          </section>
          <div className="row">
            <div className="col-xs-12">
              {editForm}
            </div>
          </div>
    </div>
  }
}

export default (Profile)



// WEBPACK FOOTER //
// ./src/components/profile/editprofile.js